/*
  FILE: RequireAuth.jsx

  PURPOSE:
  This component acts as a gatekeeper for protected routes. 
  It checks if a user is authenticated using Passport (your global auth context).
  If the user is still loading, it waits.
  If the user is not logged in, it redirects to the login page.
  If the user is authenticated, it renders the protected route.
*/

import { usePassport } from '../passport';
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const { user, loading } = usePassport();

  if (loading) return <p>Loading...</p>;

  if (!user) {
    console.warn("🔒 Blocked access — no user in session!");
    return <Navigate to="/login" replace />;
  }

  return children;
}
